import script from "./Checklist.vue?vue&type=script&setup=true&lang=ts"
export * from "./Checklist.vue?vue&type=script&setup=true&lang=ts"

import "./Checklist.vue?vue&type=style&index=0&id=19e7f231&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e7f231"]])

export default __exports__